import React from "react";
import { Form, Row, Col } from "react-bootstrap";
import Select from "react-select";
import CustomButton from "../../components/button";
import { TbFilterSearch } from "react-icons/tb";
import { TbZoomReset } from "react-icons/tb";

const Filters = ({ 
  fromDate, 
  toDate, 
  setFromDate, 
  setToDate, 
  vendors, 
  selectedVendor, 
  setSelectedVendor, 
  selectedVendorId, 
  setSelectedVendorId, 
  riders, 
  selectedRider, 
  setSelectedRider, 
  selectedRiderId, 
  setSelectedRiderId, 
  handleFilter, 
  handleReset, 
  isAdmin, 
  showApplyButton = true, // Default value to true,
  isRider=true
}) => {
  const vendorOptions = vendors.map((vendor) => ({
    value: vendor.value,
    label: vendor.label,
  }));
  const riderOptions = isRider 
    ? riders?.map((rider) => ({
        value: rider.value,
        label: rider.label,
      }))
    : [];
  const today = new Intl.DateTimeFormat('en-CA', { 
    timeZone: 'Asia/Dubai', 
    year: 'numeric', 
    month: '2-digit', 
    day: '2-digit' 
  }).format(new Date()).split("-").join("-");

  return (
    <div className="p-4 bg-light rounded shadow-lg mb-4">
      <h5 className="mb-3 text-primary">Filters</h5>
      <Row className="gx-3 gy-3">
        <Col md={4}>
          <Form.Group controlId="fromDate">
            <Form.Label className="text-secondary">From Date</Form.Label>
            <Form.Control
              type="date"
              value={fromDate}
              max={today}
              onChange={(e) => setFromDate(e.target.value)}
              className="border-primary shadow-sm"
            />
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group controlId="toDate">
            <Form.Label className="text-secondary">To Date</Form.Label>
            <Form.Control
              type="date"
              value={toDate}
              max={today}
              onChange={(e) => setToDate(e.target.value)}
              className="border-primary shadow-sm"
            />
          </Form.Group>
        </Col>
        {isAdmin && (
          <>
            <Col md={4}>
              <Form.Group controlId="vendor">
                <Form.Label className="text-secondary">Merchant</Form.Label>
                <Select
                  options={vendorOptions}
                  value={selectedVendor}
                  onChange={(selected) => {
                    if (selected) {
                      setSelectedVendor(selected);
                      setSelectedVendorId(selected.value);
                    } else {
                      setSelectedVendor(null);
                      setSelectedVendorId(null); // Clear the ID when the selection is cleared
                    }
                  }}
                  isClearable
                  placeholder="Select Merchant..."
                  isSearchable
                  className="shadow-sm"
                />
              </Form.Group>
            </Col>
            {isRider && (<Col md={4}>
              <Form.Group controlId="Rider">
                <Form.Label className="text-secondary">Rider</Form.Label>
                <Select
                  options={riderOptions}
                  value={selectedRider}
                  onChange={(selected) => {
                    if (selected) {
                      setSelectedRider(selected);
                      setSelectedRiderId(selected.value);
                    } else {
                      setSelectedRider(null);
                      setSelectedRiderId(null); // Clear the ID when the selection is cleared
                    }
                  }}
                  isClearable
                  placeholder="Select Rider..."
                  isSearchable
                  className="shadow-sm"
                />
              </Form.Group>
            </Col>)}
          </>
        )}
      </Row>
      <div className="d-flex justify-content-end mt-4 gap-3">
        {showApplyButton && (
          <CustomButton variant="primary" onClick={handleFilter} className="d-flex align-items-center gap-2 shadow">
            <TbFilterSearch size={18} /> Apply Filter
          </CustomButton>
        )}
        <CustomButton variant="secondary" onClick={handleReset} className="d-flex align-items-center gap-2 shadow">
          <TbZoomReset size={18} /> Reset
        </CustomButton>
      </div>
    </div>
  );
};

export default Filters;
